import { render, staticRenderFns } from "./transaction-source.vue?vue&type=template&id=16f736e1&"
import script from "./transaction-source.vue?vue&type=script&lang=js&"
export * from "./transaction-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports